import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.carrier}externalcarriercompanies`;

interface ExternalCarrier {
  enumValue: string;
  displayName: string;
}

async function listExternalCarrierCompanysQuery(): Promise<
  BackResponse<ExternalCarrier[]> | BackResponseFailure
> {
  try {
    const response = await apiCall<BackResponse<ExternalCarrier[]>>(ENDPOINT, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default listExternalCarrierCompanysQuery;
